import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: _ctx.valueSelect,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueSelect) = $event)),
    remote: _ctx.remote,
    clearable: "",
    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.change($event))),
    class: "m-2",
    placeholder: '请选择' + _ctx.label
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectDataList, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item[_ctx.feidId],
          label: item[_ctx.feidText],
          value: item[_ctx.feidId]
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "remote", "placeholder"]))
}